/*
  mo:mo Magazin-Hub — Themen-Filter + „Mehr laden" (clientseitig).
  „Alle" zeigt die ersten N (data-limit), Button lädt den Rest nach. Ein Themen-Filter
  zeigt ALLE passenden Cards und blendet „Mehr laden" aus. Ohne JS: alle Cards sichtbar.

  Der aktive Filter hängt am URL-Parameter ?thema=<slug> (slug = Liquid `handleize` der
  Kategorie, siehe momo-filter-bar.liquid). Damit sind gefilterte Ansichten verlinkbar —
  z. B. Footer-Links wie „Ratgeber → Schlaf". Unbekannter Slug fällt still auf „Alle".
*/
(function () {
  var PARAM = 'thema';

  /* Pill zum Slug aus der URL finden. Fallback: case-insensitiver Vergleich gegen
     data-filter, falls ein Link noch den Klartext-Namen statt des Slugs trägt. */
  function pillForSlug(pills, slug) {
    if (!slug) return null;
    var wanted = slug.toLowerCase();
    for (var i = 0; i < pills.length; i++) {
      if ((pills[i].getAttribute('data-slug') || '').toLowerCase() === wanted) return pills[i];
    }
    for (var j = 0; j < pills.length; j++) {
      if ((pills[j].getAttribute('data-filter') || '').toLowerCase() === wanted) return pills[j];
    }
    return null;
  }

  /* URL mitschreiben, ohne History-Einträge zu stapeln — der Filter ist keine Navigation. */
  function syncUrl(slug) {
    if (!window.history || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    if (slug) {
      url.searchParams.set(PARAM, slug);
    } else {
      url.searchParams.delete(PARAM);
    }
    window.history.replaceState({}, '', url);
  }

  function initHub(hub) {
    var grid = hub.querySelector('.momo-mhub__grid');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.momo-mhub__card'));
    var pills = Array.prototype.slice.call(hub.querySelectorAll('.momo-filterbar__pill'));
    var moreBtn = hub.querySelector('.momo-mhub__more');
    var limit = parseInt(hub.dataset.limit || '9', 10);
    var activeCat = '*';
    var expanded = false;

    function apply() {
      var matched = 0;
      cards.forEach(function (card) {
        var isMatch = activeCat === '*' || card.getAttribute('data-category') === activeCat;
        var visible;
        if (!isMatch) {
          visible = false;
        } else if (activeCat === '*' && !expanded) {
          visible = matched < limit;
        } else {
          visible = true;
        }
        if (isMatch) matched++;
        card.hidden = !visible;
      });
      if (moreBtn) {
        moreBtn.hidden = !(activeCat === '*' && !expanded && cards.length > limit);
      }
    }

    function activate(pill, writeUrl) {
      activeCat = pill.getAttribute('data-filter');
      expanded = false;
      pills.forEach(function (p) {
        var on = p === pill;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (writeUrl) syncUrl(pill.getAttribute('data-slug'));
      apply();
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        activate(pill, true);
      });
    });

    /* Initialer Filter aus der URL. Ohne Treffer bleibt „Alle" aktiv — kein leerer Screen. */
    var initial = pillForSlug(pills, new URLSearchParams(window.location.search).get(PARAM));
    if (initial) activate(initial, false);

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        expanded = true;
        apply();
      });
    }

    apply();
  }

  function init() {
    document.querySelectorAll('.momo-mhub').forEach(initHub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
